module.exports = __webpack_public_path__ + "media/assets/images/footer-linkeding-logo-45095bfa771d686aae5d9ecc34a3ff72.svg";